import { User } from '../models/models';

const DEFAULT_TRIAL_DAYS = 7;

export function getTrialDays(user?: User | null): number {
  if (!user) return DEFAULT_TRIAL_DAYS;
  const days = typeof user.trial_days === 'number' ? user.trial_days : DEFAULT_TRIAL_DAYS;
  return days > 0 ? days : DEFAULT_TRIAL_DAYS;
}

export function isTrialActive(user?: User | null): boolean {
  if (!user?.created_at) return false;
  const trialDays = getTrialDays(user);
  const created = new Date(user.created_at);
  const now = new Date();
  const diffMs = now.getTime() - created.getTime();
  if (diffMs < 0) return false;
  const diffDays = diffMs / (1000 * 60 * 60 * 24);
  return diffDays <= trialDays;
}

export function getTrialDaysLeft(user?: User | null): number {
  if (!user?.created_at) return 0;
  const trialDays = getTrialDays(user);
  const created = new Date(user.created_at);
  const diffDays = (Date.now() - created.getTime()) / (1000 * 60 * 60 * 24);
  const remaining = Math.ceil(trialDays - diffDays);
  return remaining > 0 ? remaining : 0;
}
